export enum UserRoles {
    // dictionaries
    dictionariesViewAndModification = "dictionaries-view-and-modification",

    // timetable
    timetableViewAndModification = "timetable-view-and-modification",

    // users
    usersView = "users-view",
    userModification = "user-modification",
    userPasswordReset = "user-password-reset",

    // ticket
    ticketView = "ticket-view",
    ticketModification = "ticket-modification",
    ticketBarcodeScanning = "ticket-barcode-scanning",

    // order
    orderView = "order-view",
    orderModification = "order-modification",
    orderStatusViewAndModification = "order-status-view-and-modification",
    orderPhotosView = "order-photos-view",
    orderFilePrinting = "order-file-printing",
    assigningWagonNumber = "assigning-wagon-number",

    // tcr
    tcrView = "tcr-view",
    tcrModification = "tcr-modification",
    tcrFilePrinting = "tcr-file-printing",

    // notifications (for tickets and orders)
    notificationsView = "notifications-view",

    // kioskPassageDirection (for tickets and orders)
    kioskPassageDirection = "kiosk-passage-direction",

    // topology
    topologyViewAndModification = "topology-view-and-modification",

    // documents
    documentsView = "documents-view",

    // alerts
    alertsViewAndModification = "alerts-view-and-modification",

    // place
    ownedVehiclesView = "owned-vehicles-view",
    parkingsView = "parkings-view",
    lightBoardsViewAndModification = "lightboards-view-and-modification",
    entryExitViewAndModification = "entry-exit-view-and-modification",

    // reports
    reportsView = "reports-view",

    // own vehicle selection
    ownVehicleSelection = "own-vehicle-selection",

    // prices list
    priceListViewAndModification = "price-list-view-and-modification"
}

export enum UserInManagementRoles {
    administrator = "/Administrator",
    supervisor = "/Supervisor",
    observer = "/Observer",
    depo = "/Depo",
    helpdesk = "/Helpdesk"
}
